export default __webpack_public_path__ + "static/media/workshop_logos_version_2.cd305f76.png";